<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />
    <!--begin::Body-->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">وصف مختصر: <span class="text-danger">*</span></label>
          <div>{{ title }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">كود الخصم: <span class="text-danger">*</span></label>
          <div>{{ code }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">نوع الخصم: <span class="text-danger">*</span></label>
          <div>{{ (discountType == 'percentage')? 'نسبة مئوية' : 'قيمة ثابتة' }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">قيمة الخصم: <span class="text-danger">*</span></label>
          <div>{{ amount }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label class="form-label">تطبيق الكوبون على:</label>
          <div>{{ dataRow.category === 'exchanges' ? 'التقبيل' : dataRow.category === 'userPackages' ? 'باقات الصيانة' : dataRow.category === 'propertyDocs' ? 'توثيق عقد' : dataRow.category === 'adLicense' ? 'طلب اصدار ترخيص اعلاني' : dataRow.category === 'photos' ? 'طلبات التصوير' : dataRow.category === 'lawyer' ? 'اطلب محاميك' : dataRow.category === 'maintenance' ? 'الصيانة' : dataRow.category === 'properties' ? 'العقارات' : 'الكل' }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">الحد الاقصى للإستخدام للعميل الواحد (إن وجد):</label>
          <div>{{ maxUserUsing }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">الحد الاقصى للإستخدام (إن وجد):</label>
          <div>{{ maxUsing }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">تاريخ الإنتهاء (إن وجد):</label>
          <div>{{ expireDate }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">الحالة:</label>
          <div>{{ (isActive)? 'نشط' : 'غير نشط' }}</div>
        </div>
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
import { formatDate } from '@/helpers/tools';

export default {
  name: 'CouponsView',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      title: '',
      code: '',
      discountType: 'percentage',
      amount: 0,
      expireDate: null,
      maxUserUsing: 0,
      maxUsing: 0,
      isActive: true,
    }
  },
  created(){
    if(this.dataRow){
      this.title = this.dataRow.title;
      this.code = this.dataRow.code;
      this.discountType = this.dataRow.discountType;
      this.amount = this.dataRow.amount;
      this.expireDate = this.dataRow.expireDate ? formatDate(this.dataRow.expireDate) : '—';
      this.maxUserUsing = this.dataRow.maxUserUsing;
      this.maxUsing = this.dataRow.maxUsing;
      this.isActive = this.dataRow.isActive;
    }
  }
}
</script>
